import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './TabView.css';
import { getTranslation } from '../../assets/creator/translations';

class TabView extends Component {
    constructor(props) {
        super(props);
        this.state = { currentTabLabel: this.props.currentTabLabel }
    }
    static propTypes = {
        children: PropTypes.arrayOf(PropTypes.element.isRequired).isRequired
    }

    SelectTab = (selectedLabel) => {
        this.setState({ currentTabLabel: selectedLabel });

    }

    isCurrentTab = tab => tab.props.label === this.state.currentTabLabel

    RenderCurrentTab() {
        if (!this.props.children) {
            return null;
        }
        let currentTabIndex = this.props.children.findIndex(this.isCurrentTab);
        if (currentTabIndex === -1) {
            currentTabIndex = 0;
        }
        return (
            <React.Fragment>
                {this.props.children.map((item, index) => {
                    if (index === currentTabIndex) {
                        return <React.Fragment key={index}>{item}</React.Fragment>;
                    }
                    return <div key={index} style={{display: "none"}}>{item}</div>;
                })}
            </React.Fragment>
        )

    }

    GetTabClassName = (tab, index) => {
        //if state is unset, first tab is active, otherwise determine from state
        if ((this.state.currentTabLabel === null && index === 0) || this.isCurrentTab(tab)) {
            return "tabview__tab tabview__tab--current";
        }
        return "tabview__tab tabview__tab--active";
    }

    RenderChildrenHeaders = () => (
        this.props.children?.map((tab, index) => (
            <li
                key={index}
                onClick={() => {
                    this.SelectTab(tab.props.label);
                    if (typeof tab.props.onSelect === "function") {
                        tab.props.onSelect();
                    }
                }}
                className={this.GetTabClassName(tab, index)}
            >
                <span>{getTranslation(tab.props.label)}</span>
            </li>
        ))
    )

    render() {
        return (
            <React.Fragment>
                <ol className="tabview" style={this.props.styleDisplay}>
                    {this.RenderChildrenHeaders()}
                </ol>
                {this.RenderCurrentTab()}
            </React.Fragment>
        )
    }
}



export default TabView;